<template>
  <div class="container-fluid">
    <div class="mt-5">
      <el-button @click="addNewUser">Přidat uživatele</el-button>
    </div>

    <div class="mt-5">
      <el-table
        v-loading="loading"
        class="mt-5"
        stripe
        :data="userList"
        style="width: 100%"
        height="calc(100vh - 200px)"
      >
        <el-table-column prop="userName" label="Uživatel" width="150"></el-table-column>
        <el-table-column prop="roles" label="Práva"></el-table-column>
        <el-table-column fixed="right" label width="120">
          <template slot-scope="scope">
            <el-button
              @click="changePasswordDialog(scope.$index, userList)"
              type="text"
              size="small"
            >Změnit</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog title="Změna uživatele" :visible.sync="centerDialogVisible" width="30%" center>
      <div class="mb-4">
        Měníte uživatele
        <b>{{ userDialogChaning.userName }}</b>
      </div>
      <el-form :model="userDialogChaning" label-width="100px" :rules="formRules" ref="userDialogChaning">
        <el-form-item label="E-mail" prop="email"
          :rules="[
            { required: true, message: 'Zadejte e-mail', trigger: 'blur' },
            { type: 'email', message: 'Formát e-mailu není správný', trigger: ['blur', 'change'] }
          ]"
        >
          <el-input placeholder="E-mail" v-model="userDialogChaning.email"></el-input>
        </el-form-item>
        <el-form-item label="Práva" prop="roles">
          <el-select v-model="userDialogChaning.roles" placeholder="Vyberte práva">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="centerDialogVisibleConfirm = true">Smazat</el-button>
        <el-button @click="centerDialogVisible = false">Zrušit</el-button>
        <el-button type="primary" @click="submitFormEdit('userDialogChaning')">Uložit</el-button>
      </span>
      <el-dialog
        width="30%"
        title="Opravdu smazat uživatele?"
        :visible.sync="centerDialogVisibleConfirm"
        append-to-body
      >
        <b>
          Tato operace je nevratná
        </b>
        <span slot="footer" class="dialog-footer">
          <el-button @click="centerDialogVisibleConfirm = false">Ne</el-button>
          <el-button type="danger" @click="removeUser">Smazat</el-button>
        </span>
      </el-dialog>
    </el-dialog>

    <el-dialog title="Přidání uživatele" :visible.sync="newUserDialog" width="30%" center>
      <el-form :model="newUserDialogForm" label-width="100px" :rules="formRules" ref="newUserDialogForm">
        <el-form-item label="Username" prop="userName">
          <el-input placeholder="Zadejte username" v-model="newUserDialogForm.userName"></el-input>
        </el-form-item>
        <el-form-item label="E-mail" prop="email"
          :rules="[
            { required: true, message: 'Zadejte e-mail', trigger: 'blur' },
            { type: 'email', message: 'Formát e-mailu není správný', trigger: ['blur', 'change'] }
          ]"
        >
          <el-input placeholder="E-mail" v-model="newUserDialogForm.email"></el-input>
        </el-form-item>
        <el-form-item label="Práva" prop="roles">
          <el-select v-model="newUserDialogForm.roles" placeholder="Vyberte práva">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="newUserDialog = false">Zrušit</el-button>
        <el-button type="primary" @click="submitForm('newUserDialogForm')">Uložit</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Logs",
  data() {
    var require = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Je to povinné pole'))
      }
      callback()
    };
    var checkPass = (rule, value, callback) => {
      let regEx = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/g
      if (!value) {
        return callback(new Error('Je to povinné pole'))
      } else if (!regEx.test(value)) {
        return callback(new Error('Minimálně 8 znaků. 1 malé a velké písmeno, jedna číslice'))
      }
      callback()
    };
    return {
      loading: false,
      userList: [],
      centerDialogVisible: false,
      centerDialogVisibleConfirm: false,
      userDialogChaning: {
        roles: "",
        email: "",
        userName: ""
      },
      newUserDialog: false,
      newUserDialogForm: {
        roles: "",
        email: "",
        userName: ""
      },
      options: [
        {
          value: "Admin",
          label: "Administrátor"
        },
        {
          value: "Uploader",
          label: "Upload záznamů"
        },
        {
          value: "Reader",
          label: "Náhled do záznamů"
        },
      ],
      formRules: {
        roles: { validator: require, trigger: 'blur' },
        userName: { required: true, message: 'Je to povinné pole', trigger: 'blur' },
      }
    };
  },
  methods: {
    removeUser() {
      this.$store.dispatch('removeUser', this.userDialogChaning)
        .then(response => {
          this.centerDialogVisible = false
          this.centerDialogVisibleConfirm = false
          this.getUsers()
        })
    },
    changePasswordDialog(index, table) {
      this.centerDialogVisible = true;
      this.userDialogChaning.userName = table[index].userName;
      this.userDialogChaning.email = table[index].email;
      this.userDialogChaning.roles = table[index].roles[0];
      this.userDialogChaning.userId = table[index].id;
    },
    addNewUser() {
      this.newUserDialog = true;
    },
    saveNewUser() {
      this.$store.dispatch('addNewUser', this.newUserDialogForm)
        .then(response => {
          this.newUserDialog = false;
          this.getUsers()
        })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveNewUser()
        } else {
          return false
        }
      })
    },
    submitFormEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveEditedUser()
        } else {
          return false
        }
      })
    },
    saveEditedUser() {
      this.$store.dispatch('editUser', this.userDialogChaning)
        .then(response => {
          this.centerDialogVisible = false
          this.getUsers()
        })
    },
    getUsers() {
      this.loading = true
      this.$store.dispatch('getUsers')
        .then(response => {
          this.userList = response.data
          this.loading = false
        })
    }
  },
  created() {
    this.getUsers()
  }
};
</script>

<style>
</style>
